module.exports = __webpack_public_path__ + "img/MObanner-1.dd1f9e7a.jpg";